export default [
  {
    path: "/purchaseinvoices/list",
    name: "purchaseinvoices-list",
    component: () => import("@/views/purchaseinvoice/list.vue"),
    meta: {
      pageTitle: "Purchase Invoices List",
      breadcrumb: [
        {
          text: "Purchase Invoices List",
          active: true,
        },
      ],
      // permission: "Permissions.Inventory.View",
    },
  },
  {
    path: "/purchaseinvoice/add",
    name: "purchaseinvoice-add",
    component: () => import("@/views/purchaseinvoice/AddMain.vue"),
    meta: {
      pageTitle: "Create Purchase Invoice",
      breadcrumb: [
        {
          text: "Purchase Invoices List",
          to: "/purchaseinvoices/list",
        },
        {
          text: "Create Purchase Invoice",
          active: true,
        },
      ],
      // permission: "Permissions.Inventory.View",
    },
  },
  {
    path: "/purchaseinvoice/edit",
    name: "purchaseinvoice-edit",
    props: true,
    component: () => import("@/views/purchaseinvoice/Edit.vue"),
    meta: {
      pageTitle: "Create Purchase Invoice",
      breadcrumb: [
        {
          text: "Purchase Invoices List",
          to: "/purchaseinvoices/list",
        },
        {
          text: "Create Purchase Invoice",
          active: true,
        },
      ],
      // permission: "Permissions.Inventory.View",
    },
  },
  {
    path: "/purchaseinvoice/view/:id",
    name: "purchaseinvoice-view",
    component: () => import("@/views/purchaseinvoice/View.vue"),
    meta: {
      pageTitle: "View Purchase Invoice",
      breadcrumb: [
        {
          text: "Purchase Invoices List",
          to: "/purchaseinvoices/list",
        },
        {
          text: "View Purchase Invoice",
          active: true,
        },
      ],
      permission: "Permissions.Inventory.View",
    },
  },
];
